module.exports = __webpack_public_path__ + "static/media/Shopify-App-Store-Badge-Final-Black.e2675ce1.svg";